
export abstract class Operation {
  reference: string;
  operationCode: string;
  operationDate: string;
  account: any;
  amount: number;
  prefixedAmount: string;
  receivingAmount: number;
  prefixedReceivingAmount: string;
  operationCost: number;
  prefixedOperationCost: string;
  operationAmountOnAccount: number;
  prefixedOperationAmountOnAccount: string;
  status: string;
  operationType: string;
  agency: any;
  organization: any;
  customer:	any;
  receiver: any;
  receivingOperation: Operation;
  sender: any;
  sendingOperation: any;
  receiverAccount: any;
  userOperatorPartner: any;
  userOperatorPartnerSecretCode: string;
  reason: string;
  idType: string;
  idNumber: string;
  cardExpiration: any;
  receiverMFS:any;
  partnerReference:string;
}

export class UserPartnerConfirmation {
  userOperatorPartnerSecretCode: string;
  userOperatorPartner: any;
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/operation/operations/operation.model.ts